const formValidationController = (function () {

	const validateName = (n) => {
		return /^[^\]+`¬\^\[%\*$|#~=!£{};:,"_=£!~?\/\\[0-9]+$/.test(n);
	}

	const validateEmail = (email) => {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	const validatePostalCode = (postal) => {
		return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postal);
	}

	// True when US numner format ("123 123 1234", "123-123-1234", "+1 123 123 1234", etc).
	const validatePhone = (phone) => {
		return /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(phone);
	}

	const isAlphaNumeric = (str) => {
		let code, i, len;

		for (i = 0, len = str.length; i < len; i++) {
			code = str.charCodeAt(i);
			if (!(code > 47 && code < 58) && // numeric (0-9)
				!(code > 64 && code < 91) && // upper alpha (A-Z)
				!(code > 96 && code < 123)) { // lower alpha (a-z)
				return false;
			}
		}
		return true;
	}

	const validateVIN = (vin) => {
		return (vin.length == 17)
	}

	return {
		validateField: function (value, pattern) {
			switch (pattern) {
				// Check field has a value
				case 'required':
					const requiredFullfilled = value.length > 0 || value === true ? true : false;
					return requiredFullfilled;
				// Check name format
				case 'name':
					return (validateName(value));
				// Check length
				case 'nameMaxMin':
					return (value.length >= 2 && value.length <= 50);
				// Check postal code
				case 'postalcode':
					return validatePostalCode(value);
				// Check email format
				case 'email':
					return validateEmail(value);
				// Check phone format
				case 'phone':
					return validatePhone(value);
				// Check alpha/numeric
				case 'isAlphaNumeric':
					return (isAlphaNumeric(value));
				// Check VIN length
				case 'vin':
					return (validateVIN(value));
				// Check Odometer is Number
				case 'odometer':
					return (!isNaN(value))
				// Check positive/negative
				case 'positive':
					return (value >= 0)
				default:
					return false;
			}
		},
	};
})();

export default formValidationController